// ... existing code ...
export const testimonials = [
  {
    id: 1,
    name: 'Jennifer Hartwell',
    location: 'Austin, TX',
    service: 'HVAC Installation',
    rating: 5,
    text: 'Renova replaced our entire HVAC system in one day. The technicians were professional, clean, and walked us through everything. Our energy bill dropped 28% in the first month. Could not be more impressed.',
    date: 'November 2024',
  },
  {
    id: 2,
    name: 'Marcus Allen',
    location: 'Phoenix, AZ',
    service: 'Heat Pump Installation',
    rating: 5,
    text: 'Switched from a gas furnace to a heat pump on Renova\'s recommendation. They handled the financing, rebate paperwork, and installation seamlessly. The whole process took less than 48 hours.',
    date: 'October 2024',
  },
  {
    id: 3,
    name: 'Diane Kowalski',
    location: 'Denver, CO',
    service: 'Maintenance Plan',
    rating: 5,
    text: 'Been on the Renova Plan for 2 years. Twice-a-year tune-ups, priority scheduling, and discounts on parts. When my furnace had an issue in January, they were at my door within 3 hours.',
    date: 'January 2025',
  },
  {
    id: 4,
    name: 'Robert Chen',
    location: 'Nashville, TN',
    service: 'Plumbing & Water Heater',
    rating: 5,
    text: 'Renova handled a complete plumbing overhaul and installed a tankless water heater. They coordinated everything, including the permit and inspection. The work was flawless.',
    date: 'September 2024',
  },
  {
    id: 5,
    name: 'Sarah O\'Brien',
    location: 'Charlotte, NC',
    service: 'Insulation & Air Quality',
    rating: 5,
    text: 'Renova did an energy audit, installed new attic insulation, and added a whole-home air purifier. We qualified for federal rebates which covered nearly 40% of the cost. Incredible service.',
    date: 'December 2024',
  },
  {
    id: 6,
    name: 'Thomas Rivera',
    location: 'Tampa, FL',
    service: 'Emergency AC Repair',
    rating: 5,
    text: 'AC failed on the hottest weekend of the year. Renova had a tech out within 90 minutes, diagnosed a failed compressor, and had a replacement unit installed by the next morning. Lifesavers.',
    date: 'August 2024',
  },
];
